import React from "react";
import { Typography } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';

const App = () => {
  
    return (
        <div style={{ minHeight: "200px", margin: "auto" }}>
        <Typography variant="h6" component="h2" color="primary" style={{ padding: "50px", textAlign: "center", fontSize: "1.25rem" }}>
            <b>ładowanie...</b>
        </Typography>
        <Typography variant="h6" component="h2" color="primary" style={{textAlign: "center" }}>
            <CircularProgress />
        </Typography>
    </div>
    );
  }

  export default () => <App />


  export const NoResult = () => {
  
    return (
        <div style={{ minHeight: "200px", margin: "auto" }}>
        <Typography variant="h6" component="h2" color="primary" style={{ padding: "50px", textAlign: "center", fontSize: "1.25rem" }}>
            <b>Brak wyników wyszukiwania</b>
        </Typography>
    </div>
    );
  }

